import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-videoads-reward-modal',
  templateUrl: './videoads-reward.component.html',
  styleUrls: ['./videoads-reward.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class VideoadsRewardModalComponent {
  videoadsRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);

  closeModal() {
    this.eventManager.closeModal(
      new Modal(this.videoadsRewardModalData.id, ModalType.Persisted, this.videoadsRewardModalData)
    );
    this.eventManager.videoAdsRedeemed(this.videoadsRewardModalData.properties.interval);
  }
}
